const ROOT = 'PAYMENT_METHOD_EDIT_DETAILS_CREDIT_CARDS_';

const actions = {
  PROCESS_ACTION_REQUEST: `${ROOT}PROCESS_ACTION_REQUEST`,
  PROCESS_ACTION_SUCCESS: `${ROOT}PROCESS_ACTION_SUCCESS`,
  PROCESS_ACTION_ERROR: `${ROOT}PROCESS_ACTION_ERROR`,
} as const;

export default actions;
